var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.onLine)?_c('div',[_vm._l((_vm.tours),function(tour){return _c('v-tour',{key:tour.id,attrs:{"name":tour.name,"steps":tour.data,"callbacks":_vm.vueToursCallbacks(tour.id)}})}),_vm._v(" "),_c('router-view')],2):_c('div',[_c('connectionLost')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-156f2933","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 